import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import VTooltip from 'v-tooltip';

import documentationFilter from '@/components/documentation/documentationFilter/index.vue';
import documentationItem from '@/components/documentation/documentationItem/index.vue';

import pagination from '@/components/pagination';
import preloader from '@/components/preloader';
import empty from '@/components/emptyContainer';

import Api from '@/utils/api';
Vue.use(VTooltip);

export default {
  components: {
    Multiselect,
    documentationFilter,
    documentationItem,
    pagination,
    preloader,
    empty,
  },
  data() {
    return {
      documentationData: [],
      responseData: {},
      changeDocument: {
        Name: '',
        Language: {},
        Client: {},
        Category: [],
        Access: [],
      },
      langList: [],
      errorCategoryList: [],
      TextCategoryList: [],
      accessList: [],

      clientList: [{
        ID: 1,
        Name: 'TEST_1',
      }, {
        ID: 2,
        Name: 'TEST_2',
      }, {
        ID: 3,
        Name: 'TEST_3',
      }],

      query: {
        page: 1,
        ppage: 9,
      },

      filterData: {},

      load: false,
    };
  },
  created() {
    this.getTextCategories();
  },
  methods: {

    /**
     * Limit text for multiselect
     *
     * @param {Number} count
     */
    limitText(count) {
      return `and ${count} others`;
    },

    getTextCategories() {
      Api.textCategory
        .get()
        .then((res) => {
          if (res.status === 200) {
            this.TextCategoryList = res.data.map((el) => el);
          }
        }).catch((err) => {
          this.$root.$emit('notification', {
            message: err,
            type: 'error',
            show: true,
          });
        });
    },
    /**
     * Get documents with filters
     * @param {Object} filter
     */
    getDocuments() {
      this.load = true;

      const params = {
        ...this.filterData,
        ...this.query,
      };

      Api.documentation
        .get(params)
        .then((response) => {
          if (response.data.Status) {
            this.documentationData = response.data.Data;
            this.responseData = response.data;
            this.load = false;
          }
        });
    },
    /**
     * Method for set filters data
     */
    setFilters(filter) {
      this.filterData = filter;
      this.query.page = 1;
      this.getDocuments();
    },

    /**
     * Method for refresh data
     */
    refresh() {
      this.getDocuments();
    },

    /**
     * Method for show popup and change selected document
     *
     * @param {Object} document
     */
    settings(document) {
      this.changeDocument = {
        ...document,
      };
      this.$modal.show('settings');
    },

    /**
     * Method for update document
     */
    updateDocument() {
      const params = {
        GUID: this.changeDocument.GUID,
        Name: this.changeDocument.Name,
        Access: this.changeDocument.Access,
        Language: this.changeDocument.Language,
        TextCategory: this.changeDocument.Category,
        Client: this.changeDocument.Client,
        FileType: this.changeDocument.FileType,
      };

      Api.documentation
        .update(params)
        .then((response) => {
          if (response.data.Status) {
            this.$root.$emit('notification', {
              message: 'Document was edited!',
              type: 'info',
              show: true,
            });
            setTimeout(() => {
              this.getDocuments();
              this.$modal.hide('settings');
            }, 2000);
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
     * Method pagination
     *
     * @param {Number} page
     */
    sendPage(page) {
      this.query.page = page;
      this.getDocuments();
    },

    /**
     * Method for multiselect
     *
     * @param {String} nameField
     * @param {Object | Array} valueField
     */
    getFilters(nameField, valueField) {
      this[nameField] = valueField;
    },
  },
};
